<template>
<div class="SignManage spackage padding-20 bgc box-shadow">
    <EventInfo :eventInfoData="eventData"></EventInfo>
    <div class="sing_manage_content_container spackage bgc box-shadow padding-20">
        <div class="flexd head">
            <div class="flexd">
                <el-button type="primary" @click="shareActive(titleinfo.signurl)">二维码签到</el-button>
                <el-button @click="downExportTicktuserList()">导出EXCEL</el-button>
                <p>报名成功：{{titleinfo.totalCount}}</p>
                <p>已签到：{{titleinfo.successSign}}</p>
                <p>未签到：{{titleinfo.notSign }}</p>
            </div>
            <div class="flexd input">
                <el-select v-model="form.signstatus" placeholder="选择状态">
                    <el-option v-for="item in issignList" :label="item.label" :value="item.value" :key="item.key"></el-option>
                </el-select>
                <el-input v-model="form.ticketno" placeholder="票号"></el-input>
                <!-- <el-input v-model="form.ownermobile" placeholder="订购人电话"></el-input> -->
                <el-input v-model="form.joinername" placeholder="报名人姓名"></el-input>
                <el-input v-model="form.customername" placeholder="订购人昵称"></el-input>
                <el-button type="primary" plain @click="search()">搜索</el-button>
            </div>
        </div>

        <div class="flexd">
            <el-table :data="eventInfoData">
                <el-table-column label="购票用户头像/昵称" width="150px">
                    <template slot-scope="scope">
                        <div class="flexd headerimg">
                            <img :src="scope.row.customericonurl" alt="item.customername">
                            <p>{{scope.row.customername}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="用户姓名">
                    <template slot-scope="scope">
                        <p v-for="(item, index) in scope.row.namelist" v-if="index <= 2">{{item}}</p>
                       <div class="flexd more" v-if="scope.row.namelist.lengt > 2">
                           <p @click="more(scope.row.namelist)" class="more-txt">更多<img src="./../../../common/images/activeOperate/down.png" alt="down"></p>
                       </div>
                        <!-- {{scope.row.ownercustomername}}
                         <div class="more">
                           <p>更多</p>
                           <ul>
                               <li>111</li>
                               <li>111</li>
                               <li>111</li>
                           </ul>
                       </div> -->
                    </template>
                </el-table-column>
                <el-table-column label="手机号码">
                    <template slot-scope="scope">
                        <!-- {{scope.row.mobilelist}} -->
                        <p v-for="(item, index) in scope.row.mobilelist" v-if="index <= 2">{{item}}</p>
                       <div class="flexd more" v-if="scope.row.mobilelist.length > 2">
                           <p @click="more(scope.row.mobilelist)" class="more-txt">更多<img src="./../../../common/images/activeOperate/down.png" alt="down"></p>
                       </div>
                    </template>
                </el-table-column>
                <el-table-column label="票种" prop="ticketname"></el-table-column>
                <el-table-column label="价格（元）">
                    <template slot-scope="scope">
                        <p style="color: #FF4747"> <template v-if="scope.row.uprice !== '免费'">¥</template> {{scope.row.uprice}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="票号">
                    <template slot-scope="scope">
                        <p v-for="(item, index) in scope.row.ticketlist" v-if="index <= 2">{{item}}</p>
                       <div class="flexd more" v-if="scope.row.ticketlist.length > 2">
                           <p @click="more(scope.row.ticketlist)" class="more-txt">更多<img src="./../../../common/images/activeOperate/down.png" alt="down"></p>
                       </div>
                    </template>
                </el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                       <p v-if="scope.row.issign == 0" style="color:#FFA904">待签到</p>
                       <p v-else style="color:#0ABF53">已签到</p>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <p style="color: #439FFE" v-if="scope.row.issign == 0" @click="updatEventticketUserStatus(scope.row.signid, 1)">签到</p>
                        <p style="color: #439FFE" v-else @click="updatEventticketUserStatus(scope.row.signid, 0)">取消签到</p>
                    </template>
                </el-table-column>
            </el-table>
        </div>


        <el-dialog title="更多" :visible.sync="silderDialogVisible" width="500px">
            <div class="silder">
                <template v-for="(item, index) in moreinfo">
                    <p>{{item}}</p>
                </template>
                <!-- 免费票
                <el-progress :percentage="50" :format="format"></el-progress>
                vip
                <el-progress :percentage="10" :format="format"></el-progress>
                四人票
                <el-progress :percentage="6" :format="format"></el-progress> -->
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="silderDialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>


         <el-pagination background layout="prev, pager, next" :total="totalPage"  @current-change="fPage"></el-pagination>
    </div>
     <CopyShareDialog :shareeventurl="shareeventurl" :imgurl="imgurl" :copyShareStatus='copyShareStatus' @closeCopyShareStatus='closeCopyShareStatus'></CopyShareDialog>
</div>
</template>

<script>
import {dateFormat} from 'common/js/tools'
import EventInfo from 'views/activeOperate/components/EventInfo'
import CopyShareDialog from 'views/activeOperate/components/CopyShareDialog'
import {getTicketuserList, exportTicktuserList, updatEventticketUserStatus, statisticalSignNum, eventInfo} from 'api/activeApi'
import { urlToQRCode} from 'common/js/tools'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'SignManage',
    data() {
        return {
            imgurl: '', 
            issignList: [{value: '',label:"全部状态"},{value:0,label:"待签到"},{value:1,label:"已签到"}],
            titleinfo: {},
            copyShareStatus: false, // 分享状态
            shareeventurl: '', // 分享链接
            silderDialogVisible: false,
            eventData: {},
            eventInfoData: [],
            moreinfo: [], // 更多数据
            totalPage: 0,    //数据条数
            form: {
                eventinnerid: this.$route.query.eventinnerid, //该活动的innerid
                ticketno: '',	// 票号
                signstatus: '',    // 签到状态
                customername: '',	// 订购人姓名
                joinername: '', // 报名人姓名
                page: 1,
                pageSize: 10
            }
        }
    },
    mounted() {
        this.getEventData()
        this.statisticalSignNum()
        this.findSimpleEventDetail(1)
    },
    methods: {
        // 获取顶部活动信息
        getEventData() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            eventInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.eventData = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        statisticalSignNum() {
            this.setLoading(true)
            statisticalSignNum({
                data: {eventinnerid: this.form.eventinnerid},
                success: data => {
                     this.setLoading(false)
                     this.titleinfo = data.data
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
         shareActive(shareeventurl) {  // 分享
                this.copyShareStatus = true
                this.shareeventurl = shareeventurl
                this.imgurl = urlToQRCode(shareeventurl)

        },
         closeCopyShareStatus(val) { // 关闭复制弹窗
                this.copyShareStatus = false
            },
        more(info) {
            this.moreinfo = []
            this.silderDialogVisible = true
            this.moreinfo = info
        },
        updatEventticketUserStatus(orderno, type) {  // 修改签到状态
         this.setLoading(true)
            updatEventticketUserStatus({
                data: {eventinnerid: this.form.eventinnerid, signid: orderno, issign: type},
                success: data => {
                     this.setLoading(false)
                     this.$message.success('操作成功')
                     this.statisticalSignNum()
                     this.findSimpleEventDetail(1)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        fPage(){    // 分页
            let clickPage = $(".el-pagination .active").html()
            this.findSimpleEventDetail(clickPage)
        },
        search() {  // 搜索
            this.findSimpleEventDetail(1)
        },
        // 查询活动基本简略信息
        findSimpleEventDetail(page) {
           this.form.page = page
            this.setLoading(true)
            getTicketuserList({
                data: this.form,
                success: data => {
                    this.setLoading(false)
                    this.eventInfoData = data.data.content
                    this.totalPage = data.data.pageinfo.rowCount
                    // console.log('this.eventInfoData:', this.eventInfoData);
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        downExportTicktuserList() { // 下载 Excel文件
            this.setLoading(true)
            exportTicktuserList({
                data: this.form,
                success:data => {
                    this.setLoading(false)
                    this.$message.success('下载成功')
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '签到管理' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error:data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        EventInfo,
        CopyShareDialog
    }
}
</script>

<style lang="scss" type="text/scss">
.SignManage {
    font-family:PingFangSC-Regular,PingFang SC;
    .sing_manage_content_container {
        margin-top: 24px;
        .el-tabs__item {
            padding: 0 20px!important;
        }
        .el-tabs__header {
            margin: 0 0 24px;
        }
    }
    .more {
        justify-content: center IMPORTANT;

        .more-txt {
            text-align: center;
            color: #999
        }
        img {
            margin-left: 9px;
            transform: translateY(2px);
            width: 16px !IMPORTANT;
            height: 16px !IMPORTANT;
            background: none !IMPORTANT;
        }
    }
    
    .flexd {
        display: flex;
        flex-wrap: nowrap;
        -ms-flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
    }
    // table {
    //     width: 100%;
    //     margin-top: 37px;
    //     tr {
    //         th {
    //             height: 37px;
    //             line-height: 37px;
    //             font-size: 16px;
    //             background: #FAFAFA;
    //         }
    //     }
    // }
    .el-pagination {
        margin-top: 16px;
        text-align: center;
    }
    .el-input__icon {
        line-height: 32px;
    }
    .head {
        margin-bottom: 30px;
        line-height: 32px;

        p {
            margin-left: 10px;
            font-size: 14px;
        }

        .el-input {
            margin-right: 10px;
            max-width: 120px;

            input {
                width: 100%;
            }
        }
        
    }

    .el-table {
        .headerimg {
            justify-content: left;
        }
        img {
            margin-right: 10px;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background: #ccc
        }
        
    }
    .silder {
        p {
            margin-bottom: 10px;
            text-align: center;
        }
    }
}
</style>